// extracted by mini-css-extract-plugin
export var breadcrumb = "_1a-0";
export var breadcrumbArrow = "_1a-1";